import React from 'react';
import { Box, Drawer } from '@mui/material';

interface Props {
  openDrawer: any;
  setOpenDrawer: any;

}

const DrawerComp = (props: Props) => {
  const { openDrawer, setOpenDrawer } = props;
  const { isOpen, position, showData } = openDrawer;
  
  return (
    <Drawer open={isOpen} anchor={position} onClose={() => setOpenDrawer({ ...openDrawer, isOpen: false })}>
      <Box sx={{ width: 230 }} role="presentation">
        {showData === 'menu' && <div>menu</div>}
        {showData === 'notification' && <div>notification</div>}
        {showData === 'user-info' && <div>user info</div>}
      </Box>
    </Drawer>
  )
}

export default DrawerComp